interface VersionCheckOptions {
  currentVersion?: string;
  versionUrl?: string;
  intervalMs?: number;
  onUpdate?: (latestVersion: string) => void;
}

const DEFAULT_VERSION_URL = '/build/version.json';
const DEFAULT_INTERVAL_MS = 5 * 60 * 1000;

function extractVersion(payload: unknown): string | null {
  if (payload && typeof payload === 'object' && 'commit_short' in payload) {
    const commitShort = (payload as { commit_short?: string }).commit_short;
    return typeof commitShort === 'string' ? commitShort : null;
  }
  if (typeof payload === 'string') {
    return payload;
  }
  return null;
}
export function startVersionCheck(options: VersionCheckOptions): () => void {
  const currentVersion = options.currentVersion?.trim();
  if (!currentVersion) {
    return () => undefined;
  }

  const versionUrl = options.versionUrl || DEFAULT_VERSION_URL;
  const intervalMs = options.intervalMs ?? DEFAULT_INTERVAL_MS;
  let timer: ReturnType<typeof setInterval> | null = null;
  let stopped = false;

  const stop = () => {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    stopped = true;
  };

  const checkOnce = async () => {
    if (stopped) return;

    try {
      const response = await fetch(`${versionUrl}?t=${Date.now()}`, { cache: 'no-store' });
      if (!response.ok) return;

      const payload = await response.json();
      const latestVersion = extractVersion(payload);
      if (!latestVersion || latestVersion === currentVersion) return;

      options.onUpdate?.(latestVersion);
      stop();
    } catch {
      // Ignore fetch/parse errors and retry later.
    }
  };

  checkOnce();
  timer = setInterval(checkOnce, intervalMs);

  return stop;
}
